module.exports = __webpack_public_path__ + "3b67-1300.png";